// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file inventory/v1/category.proto (package inventory.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/category.proto.
 */
export const file_inventory_v1_category: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_google_protobuf_struct, file_types]);

/**
 * Category message definition
 *
 * @generated from message inventory.v1.Category
 */
export type Category = Message<"inventory.v1.Category"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Struct attributes = 4;
   */
  attributes?: JsonObject;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 5;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: types.Base base = 6;
   */
  base?: Base;
};

/**
 * Describes the message inventory.v1.Category.
 * Use `create(CategorySchema)` to create a new message.
 */
export const CategorySchema: GenMessage<Category> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 0);

/**
 * Request/Response messages for Category queries
 *
 * @generated from message inventory.v1.GetCategoryRequest
 */
export type GetCategoryRequest = Message<"inventory.v1.GetCategoryRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.GetCategoryRequest.
 * Use `create(GetCategoryRequestSchema)` to create a new message.
 */
export const GetCategoryRequestSchema: GenMessage<GetCategoryRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 1);

/**
 * @generated from message inventory.v1.GetCategoryResponse
 */
export type GetCategoryResponse = Message<"inventory.v1.GetCategoryResponse"> & {
  /**
   * @generated from field: inventory.v1.Category category = 1;
   */
  category?: Category;
};

/**
 * Describes the message inventory.v1.GetCategoryResponse.
 * Use `create(GetCategoryResponseSchema)` to create a new message.
 */
export const GetCategoryResponseSchema: GenMessage<GetCategoryResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 2);

/**
 * @generated from message inventory.v1.ListCategoriesRequest
 */
export type ListCategoriesRequest = Message<"inventory.v1.ListCategoriesRequest"> & {
  /**
   * @generated from field: inventory.v1.ListCategoriesFilter filter = 1;
   */
  filter?: ListCategoriesFilter;

  /**
   * @generated from field: repeated inventory.v1.CategorySortOption sorting = 2;
   */
  sorting: CategorySortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message inventory.v1.ListCategoriesRequest.
 * Use `create(ListCategoriesRequestSchema)` to create a new message.
 */
export const ListCategoriesRequestSchema: GenMessage<ListCategoriesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 3);

/**
 * @generated from message inventory.v1.ListCategoriesFilter
 */
export type ListCategoriesFilter = Message<"inventory.v1.ListCategoriesFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue name = 2;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue description = 3;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 6;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 7;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.ListCategoriesFilter.
 * Use `create(ListCategoriesFilterSchema)` to create a new message.
 */
export const ListCategoriesFilterSchema: GenMessage<ListCategoriesFilter> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 4);

/**
 * @generated from message inventory.v1.ListCategoriesResponse
 */
export type ListCategoriesResponse = Message<"inventory.v1.ListCategoriesResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Category categories = 1;
   */
  categories: Category[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message inventory.v1.ListCategoriesResponse.
 * Use `create(ListCategoriesResponseSchema)` to create a new message.
 */
export const ListCategoriesResponseSchema: GenMessage<ListCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 5);

/**
 * Command messages
 *
 * @generated from message inventory.v1.CreateCategoryRequest
 */
export type CreateCategoryRequest = Message<"inventory.v1.CreateCategoryRequest"> & {
  /**
   * @generated from field: inventory.v1.CategoryInput input = 1;
   */
  input?: CategoryInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.CreateCategoryRequest.
 * Use `create(CreateCategoryRequestSchema)` to create a new message.
 */
export const CreateCategoryRequestSchema: GenMessage<CreateCategoryRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 6);

/**
 * @generated from message inventory.v1.CreateCategoryResponse
 */
export type CreateCategoryResponse = Message<"inventory.v1.CreateCategoryResponse"> & {
  /**
   * @generated from field: inventory.v1.Category category = 1;
   */
  category?: Category;
};

/**
 * Describes the message inventory.v1.CreateCategoryResponse.
 * Use `create(CreateCategoryResponseSchema)` to create a new message.
 */
export const CreateCategoryResponseSchema: GenMessage<CreateCategoryResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 7);

/**
 * @generated from message inventory.v1.UpdateCategoryRequest
 */
export type UpdateCategoryRequest = Message<"inventory.v1.UpdateCategoryRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: inventory.v1.CategoryUpdateInput input = 2;
   */
  input?: CategoryUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.UpdateCategoryRequest.
 * Use `create(UpdateCategoryRequestSchema)` to create a new message.
 */
export const UpdateCategoryRequestSchema: GenMessage<UpdateCategoryRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 8);

/**
 * @generated from message inventory.v1.UpdateCategoryResponse
 */
export type UpdateCategoryResponse = Message<"inventory.v1.UpdateCategoryResponse"> & {
  /**
   * @generated from field: inventory.v1.Category category = 1;
   */
  category?: Category;
};

/**
 * Describes the message inventory.v1.UpdateCategoryResponse.
 * Use `create(UpdateCategoryResponseSchema)` to create a new message.
 */
export const UpdateCategoryResponseSchema: GenMessage<UpdateCategoryResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 9);

/**
 * @generated from message inventory.v1.DeleteCategoryRequest
 */
export type DeleteCategoryRequest = Message<"inventory.v1.DeleteCategoryRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.DeleteCategoryRequest.
 * Use `create(DeleteCategoryRequestSchema)` to create a new message.
 */
export const DeleteCategoryRequestSchema: GenMessage<DeleteCategoryRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 10);

/**
 * Input messages
 *
 * @generated from message inventory.v1.CategoryInput
 */
export type CategoryInput = Message<"inventory.v1.CategoryInput"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Struct attributes = 3;
   */
  attributes?: JsonObject;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 4;
   */
  customAttributes: { [key: string]: Value };
};

/**
 * Describes the message inventory.v1.CategoryInput.
 * Use `create(CategoryInputSchema)` to create a new message.
 */
export const CategoryInputSchema: GenMessage<CategoryInput> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 11);

/**
 * @generated from message inventory.v1.CategoryUpdateInput
 */
export type CategoryUpdateInput = Message<"inventory.v1.CategoryUpdateInput"> & {
  /**
   * @generated from field: google.protobuf.StringValue name = 1;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue description = 2;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.StringValue attributes = 3;
   */
  attributes?: string;

  /**
   * @generated from field: google.protobuf.StringValue custom_attributes = 4;
   */
  customAttributes?: string;
};

/**
 * Describes the message inventory.v1.CategoryUpdateInput.
 * Use `create(CategoryUpdateInputSchema)` to create a new message.
 */
export const CategoryUpdateInputSchema: GenMessage<CategoryUpdateInput> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 12);

/**
 * GetCategoriesByCustomAttributeRequest - custom query request
 *
 * @generated from message inventory.v1.GetCategoriesByCustomAttributeRequest
 */
export type GetCategoriesByCustomAttributeRequest = Message<"inventory.v1.GetCategoriesByCustomAttributeRequest"> & {
  /**
   * @generated from field: string attribute_name = 1;
   */
  attributeName: string;

  /**
   * @generated from field: repeated string attribute_values = 2;
   */
  attributeValues: string[];

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.GetCategoriesByCustomAttributeRequest.
 * Use `create(GetCategoriesByCustomAttributeRequestSchema)` to create a new message.
 */
export const GetCategoriesByCustomAttributeRequestSchema: GenMessage<GetCategoriesByCustomAttributeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 13);

/**
 * GetCategoriesByCustomAttributeResponse - custom query response
 *
 * @generated from message inventory.v1.GetCategoriesByCustomAttributeResponse
 */
export type GetCategoriesByCustomAttributeResponse = Message<"inventory.v1.GetCategoriesByCustomAttributeResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Category result = 1;
   */
  result: Category[];
};

/**
 * Describes the message inventory.v1.GetCategoriesByCustomAttributeResponse.
 * Use `create(GetCategoriesByCustomAttributeResponseSchema)` to create a new message.
 */
export const GetCategoriesByCustomAttributeResponseSchema: GenMessage<GetCategoriesByCustomAttributeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 14);

/**
 * CheckCategorySearchPermissionsRequest - custom query request
 *
 * @generated from message inventory.v1.CheckCategorySearchPermissionsRequest
 */
export type CheckCategorySearchPermissionsRequest = Message<"inventory.v1.CheckCategorySearchPermissionsRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.CheckCategorySearchPermissionsRequest.
 * Use `create(CheckCategorySearchPermissionsRequestSchema)` to create a new message.
 */
export const CheckCategorySearchPermissionsRequestSchema: GenMessage<CheckCategorySearchPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 15);

/**
 * CheckCategorySearchPermissionsResponse - custom query response
 *
 * @generated from message inventory.v1.CheckCategorySearchPermissionsResponse
 */
export type CheckCategorySearchPermissionsResponse = Message<"inventory.v1.CheckCategorySearchPermissionsResponse"> & {
  /**
   * @generated from field: repeated string result = 1;
   */
  result: string[];
};

/**
 * Describes the message inventory.v1.CheckCategorySearchPermissionsResponse.
 * Use `create(CheckCategorySearchPermissionsResponseSchema)` to create a new message.
 */
export const CheckCategorySearchPermissionsResponseSchema: GenMessage<CheckCategorySearchPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_category, 16);

/**
 * @generated from enum inventory.v1.CategorySortOption
 */
export enum CategorySortOption {
  /**
   * @generated from enum value: CATEGORY_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CATEGORY_SORT_OPTION_NAME_ASC = 1;
   */
  NAME_ASC = 1,

  /**
   * @generated from enum value: CATEGORY_SORT_OPTION_NAME_DESC = 2;
   */
  NAME_DESC = 2,

  /**
   * @generated from enum value: CATEGORY_SORT_OPTION_DESCRIPTION_ASC = 3;
   */
  DESCRIPTION_ASC = 3,

  /**
   * @generated from enum value: CATEGORY_SORT_OPTION_DESCRIPTION_DESC = 4;
   */
  DESCRIPTION_DESC = 4,

  /**
   * @generated from enum value: CATEGORY_SORT_OPTION_CREATED_AT_ASC = 5;
   */
  CREATED_AT_ASC = 5,

  /**
   * @generated from enum value: CATEGORY_SORT_OPTION_CREATED_AT_DESC = 6;
   */
  CREATED_AT_DESC = 6,

  /**
   * @generated from enum value: CATEGORY_SORT_OPTION_UPDATED_AT_ASC = 7;
   */
  UPDATED_AT_ASC = 7,

  /**
   * @generated from enum value: CATEGORY_SORT_OPTION_UPDATED_AT_DESC = 8;
   */
  UPDATED_AT_DESC = 8,
}

/**
 * Describes the enum inventory.v1.CategorySortOption.
 */
export const CategorySortOptionSchema: GenEnum<CategorySortOption> = /*@__PURE__*/
  enumDesc(file_inventory_v1_category, 0);

/**
 * Services
 *
 * @generated from service inventory.v1.CategoryQueriesService
 */
export const CategoryQueriesService: GenService<{
  /**
   * @generated from rpc inventory.v1.CategoryQueriesService.GetCategory
   */
  getCategory: {
    methodKind: "unary";
    input: typeof GetCategoryRequestSchema;
    output: typeof GetCategoryResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CategoryQueriesService.ListCategories
   */
  listCategories: {
    methodKind: "unary";
    input: typeof ListCategoriesRequestSchema;
    output: typeof ListCategoriesResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CategoryQueriesService.GetCategoriesByCustomAttribute
   */
  getCategoriesByCustomAttribute: {
    methodKind: "unary";
    input: typeof GetCategoriesByCustomAttributeRequestSchema;
    output: typeof GetCategoriesByCustomAttributeResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CategoryQueriesService.CheckSearchPermissions
   */
  checkSearchPermissions: {
    methodKind: "unary";
    input: typeof CheckCategorySearchPermissionsRequestSchema;
    output: typeof CheckCategorySearchPermissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_category, 0);

/**
 * @generated from service inventory.v1.CategoryCommandsService
 */
export const CategoryCommandsService: GenService<{
  /**
   * @generated from rpc inventory.v1.CategoryCommandsService.CreateCategory
   */
  createCategory: {
    methodKind: "unary";
    input: typeof CreateCategoryRequestSchema;
    output: typeof CreateCategoryResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CategoryCommandsService.UpdateCategory
   */
  updateCategory: {
    methodKind: "unary";
    input: typeof UpdateCategoryRequestSchema;
    output: typeof UpdateCategoryResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CategoryCommandsService.DeleteCategory
   */
  deleteCategory: {
    methodKind: "unary";
    input: typeof DeleteCategoryRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_category, 1);

